import { StateDeclaration, UIRouter } from "@uirouter/angular";
import { Title } from "@angular/platform-browser";
import { AppsService } from "../services/applications.service";

export function pageTitleConfig(router: UIRouter) {
    router.transitionService.onSuccess({}, (transition) => {
        const titleService =  transition.injector().get<Title>(Title);
        const apssService =  transition.injector().get<AppsService>(AppsService);
        const toState: StateDeclaration = transition.to();
        const appTitle = apssService.getApplicationSync(toState.data?.app)?.text || 'PROS';
        const newTitle = (toState.data && toState.data.pageTitle) ? `${appTitle} - ${toState.data.pageTitle}` : appTitle;
        titleService.setTitle(newTitle);
    })
}
